var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { XForm } from "@bluelibs/x-ui-admin";
import { Routes } from "@bundles/UIAppBundle";
import { Service, Inject } from "@bluelibs/core";
import { features } from "./features";
import { CompaniesCollection, BankAccountsCollection, TransactionsCollection, } from "@bundles/UIAppBundle/collections";
import { ApolloError } from "@apollo/client";
let TransactionCreateForm = class TransactionCreateForm extends XForm {
    setFormRef(formRef) {
        this.formRef = formRef;
    }
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "sourceBankAccountId",
                label: t("management.transactions.fields.sourceBankAccount"),
                name: ["sourceBankAccountId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BankAccountsCollection, field: "accountNumber", required: false }, void 0) }), void 0)),
            },
            {
                id: "destinationBankAccountId",
                label: t("management.transactions.fields.destinationBankAccount"),
                name: ["destinationBankAccountId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BankAccountsCollection, field: "accountNumber", required: false }, void 0) }), void 0)),
            },
            {
                id: "companyId",
                label: t("management.transactions.fields.company"),
                name: ["companyId"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", required: true }, void 0) }), void 0)),
            },
            {
                id: "externalId",
                label: t("management.transactions.fields.external"),
                name: ["externalId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Select, { options: [] }, void 0) }), void 0)),
            },
            {
                id: "amount",
                label: t("management.transactions.fields.amount"),
                name: ["amount"],
                required: true,
                component: Ant.InputNumber,
            },
            {
                id: "transactionDate",
                label: t("management.transactions.fields.transactionDate"),
                name: ["transactionDate"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.DatePicker, { required: true }, void 0) }), void 0)),
            },
            {
                id: "dueDate",
                label: t("management.transactions.fields.dueDate"),
                name: ["dueDate"],
                tooltip: t("management.transactions.fields.dueDate_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.DatePicker, { required: false }, void 0) }), void 0)),
            },
            {
                id: "isCompleted",
                label: t("management.transactions.fields.isCompleted"),
                name: ["isCompleted"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsxs(Ant.Radio.Group, { children: [_jsx(Ant.Radio, Object.assign({ value: false }, { children: "No" }), 0), _jsx(Ant.Radio, Object.assign({ value: true }, { children: "Yes" }), 1)] }, void 0) }), void 0)),
            },
            {
                id: "transactionIdentifier",
                label: t("management.transactions.fields.transactionIdentifier"),
                name: ["transactionIdentifier"],
                component: Ant.Input,
            },
            {
                id: "completeDate",
                label: t("management.transactions.fields.completeDate"),
                name: ["completeDate"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.DatePicker, { required: false }, void 0) }), void 0)),
            },
            {
                id: "notes",
                label: t("management.transactions.fields.notes"),
                name: ["notes"],
                component: Ant.Input,
            },
            {
                id: "transactionFilesIds",
                label: t("management.transactions.fields.transactionFiles"),
                name: ["transactionFilesIds"],
                component: UIComponents.AdminFilesUpload,
                componentProps: { field: "_id" },
            },
        ]);
    }
    onSubmit(document, redirect, onSuccessCallback) {
        const { t } = this.i18n;
        return this.collection
            .insertOne(document)
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.transactions.create_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            if (redirect) {
                if (features.view) {
                    return this.router.go(Routes.TRANSACTIONS_VIEW, {
                        params: {
                            id: _id,
                        },
                    });
                }
                if (features.list) {
                    return this.router.go(Routes.TRANSACTIONS_LIST);
                }
                if (features.edit) {
                    return this.router.go(Routes.TRANSACTIONS_EDIT, {
                        params: {
                            id: _id,
                        },
                    });
                }
            }
            onSuccessCallback && onSuccessCallback();
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    }
};
__decorate([
    Inject(() => TransactionsCollection),
    __metadata("design:type", typeof (_a = typeof TransactionsCollection !== "undefined" && TransactionsCollection) === "function" ? _a : Object)
], TransactionCreateForm.prototype, "collection", void 0);
TransactionCreateForm = __decorate([
    Service({ transient: true })
], TransactionCreateForm);
export { TransactionCreateForm };
